import api from 'service/api'

const dponetAPInotTrait = api.create('dponet', false)

const get = async ({ ...params }) => {
  return await dponetAPInotTrait.get('/regulation_versions', { params })
}

const accept = async (regulationVersionId) => {
  return await dponetAPInotTrait.post(
    `/regulation_versions/${regulationVersionId}/regulation_version_acceptances`,
  )
}

const regulationVersions = {
  get,
  accept,
}

export default regulationVersions
